export const Props = () => ({
  //Id поста, к которому будет отправляться форма
  postId: {
    type: Number,
    required: true,
  },

  //ID коммента
  commentId:{
    type: Number,
    required: false,
  },
  
  //Id комментария, к которому привязывается форма
  selfId: {
    type: Number,
    required: false,
  },

  //Фокусироваться ли сразу на форме после ее рендера
  isFocus: {
    type: Boolean,
    default: false,
    required: false,
  },

  //Контекст вызова комментариев (инфошум / сигналы)
  context:{
    type: String,
    required: false,
    default: 'infonoise',
    validator: (value) => {
      const allowedTypes = ['infonoise', 'signal'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'context' в компоненте CommentsForm может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  },

  //Где рендериться список комментариев? (В попапе или на странице)
  commentsPlace: {
    type: String,
    required: true,
    validator: (value) => {
      const allowedTypes = ['popup', 'page'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'commentsPlace' в компоненте CommentsForm может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  }
});